// src/app/app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './core/auth.guard'; // <-- Import the AuthGuard
import { HistoryComponent } from './history/history.component';
import { HomeComponent } from './home/home.component';
import { ReadyComponent } from './ready/ready.component';
import { ClientsComponent } from './clients/clients.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { InventoryComponent } from './inventory/inventory.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { TrackingComponent } from './tracking/tracking.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { ComissionsComponent } from './comissions/comissions.component';
import { InspectionComponent } from './inspection/inspection.component';
import { InspeccionesViewComponent } from './inspecciones-view/inspecciones-view.component';

const routes: Routes = [
  // Redirect root path to login or dashboard based on auth status (handled by guard)
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard], // <-- Protect this route with the guard
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard], // <-- Protect this route with the guard
  },
  {
    path: 'clients', // <-- AÑADIR NUEVA RUTA
    component: ClientsComponent,
    canActivate: [AuthGuard],
  },
  {
    // <-- NUEVA RUTA para el historial
    path: 'history',
    component: HistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    // <-- NUEVA RUTA para el historial
    path: 'ready',
    component: ReadyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'inventory',
    component: InventoryComponent,
    canActivate: [AuthGuard],
  }, // NUEVO
  { path: 'track/:caseNumber', component: TrackingComponent }, // RUTA PÚBLICA NUEVA
  { path: 'portal', component: ClientPortalComponent },
  {
  path: 'inspection/:caseNumber', // El uso de :workId permite recibir el identificador de la orden
  component: InspectionComponent,
  canActivate: [AuthGuard],
},
  {
    path: 'appointments',
    component: AppointmentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'inspecciones',
    component: InspeccionesViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'analytics',
    component: AnalyticsComponent,
    canActivate: [AuthGuard],
    // PASAMOS EL ROL REQUERIDO COMO DATA
    data: { role: 'manager' },
  },
  {
    path: 'comisiones',
    component: ComissionsComponent,
    canActivate: [AuthGuard],
    // PASAMOS EL ROL REQUERIDO COMO DATA
    data: { role: 'manager' },
  },
  // Add other routes here
  { path: '**', redirectTo: '/login' }, // Wildcard route redirects to login if no other match
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
